import { frbs, Auth, FDB } from '../game/firebase.js'

const FB_LS_TOKEN = 'firebase-token'
// email login verification
export const CONFIG = {
  protocol: process.env.NODE_ENV === 'production' ? 'https' : 'http',
  domain: process.env.NODE_ENV === 'production' ? 'the-cell-game.com' : 'localhost:' + window.location.port
}
export const State = {
  user: false,
  token: false,
  hydrationComplete: false
}

export const waitHydration = () => {
  return new Promise((resolve) => {
    let tt = setInterval(() => {
      if (State.hydrationComplete) {
        clearInterval(tt)
        resolve()
      }
    }, 10)
  })
}

export const waitTilLoggedIn = () => {
  return new Promise((resolve) => {
    let tt = setInterval(() => {
      if (State.user) {
        clearInterval(tt)
        resolve()
      }
    }, 10)
  })
}

Auth.onAuthStateChanged((user) => {
  if (user) {
    // User is signed in.
    State.user = JSON.parse(JSON.stringify(user))
    State.token = window.localStorage.getItem(FB_LS_TOKEN)
    State.hydrationComplete = true
    // console.log(user)
    if (user.isAnonymous) {
      FDB.ref('users/' + user.uid).set({
        uid: user.uid,
        isAnonymous: user.isAnonymous
      })
    } else {
      FDB.ref('users/' + user.uid).set({
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        pic: user.photoURL,
        isAnonymous: user.isAnonymous
      })
    }
  } else {
    State.user = false
    State.token = false
    State.hydrationComplete = true
    window.localStorage.removeItem(FB_LS_TOKEN)
    // No user is signed in.
  }
})

export const sendEmailLinkLogin = (email, redirect = '') => {
  var actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be whitelisted in the Firebase Console.
    url: `${CONFIG.protocol}://${CONFIG.domain}/${redirect}`,
    // This must be true.
    handleCodeInApp: true
    // iOS: {
    //   bundleId: 'com.example.ios'
    // },
    // android: {
    //   packageName: 'com.example.android',
    //   installApp: true,
    //   minimumVersion: '12'
    // },
    // dynamicLinkDomain: 'example.page.link'
  }
  return Auth.sendSignInLinkToEmail(email, actionCodeSettings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem('emailForSignIn', email)
    })
    // .catch((error) => {
    //   console.log(error)
    //   // Some error occurred, you can inspect the code: error.code
    // })
}

export const onEmailLinkArrive = ({ silent, canWait = () => {} } = { silent: true, canWait: () => {} }) => {
  // let link = `https://cell-game.netlify.com/on-email-arrive`
  // Confirm the link is a sign-in with email link.
  if (Auth.isSignInWithEmailLink(window.location.href)) {
    // Additional state parameters can also be passed via URL.
    // This can be used to continue the user's intended action before triggering
    // the sign-in operation.
    // Get the email if available. This should be available if the user completes
    // the flow on the same device where they started it.
    var email = window.localStorage.getItem('emailForSignIn')
    if (email) {
      canWait()
    }
    if (!email) {
      if (silent) {
        return
      }
      // User opened the link on a different device. To prevent session fixation
      // attacks, ask the user to provide the associated email again. For example:
      email = window.prompt('Please provide your email for confirmation')
    }
    // The client SDK will parse the code from the link for you.
    Auth.signInWithEmailLink(email, window.location.href)
      .then((result) => {
        // Clear email from storage.
        window.localStorage.removeItem('emailForSignIn')
        console.log(result)

        if (!silent) {
          window.location.assign('/')
        }

        // You can access the new user via result.user
        // Additional user info profile not available via:
        // result.additionalUserInfo.profile == null
        // You can check if the user is new or existing:
        // result.additionalUserInfo.isNewUser
      })
      .catch((error) => {
        console.log(error)
        // Some error occurred, you can inspect the code: error.code
        // Common errors could be invalid email and invalid or expired OTPs.
      })
  }
}

export const loginAnonymous = () => {
  return Auth.signInAnonymously().catch((error) => {
    // Handle Errors here.
    // var errorCode = error.code;
    // var errorMessage = error.message;
    // // ...
    console.log(error)
    return Promise.reject(error)
  })
}

export const loginFacebook = () => {
  var provider = new frbs.auth.FacebookAuthProvider()
  return Auth.signInWithPopup(provider).then((result) => {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken
    // The signed-in user info.
    var user = result.user
    // ...
    State.user = user
    State.token = token
    window.localStorage.setItem(FB_LS_TOKEN, token)

    return Promise.resolve(State.user)
  }).catch((error) => {
    // // Handle Errors here.
    // var errorCode = error.code
    // var errorMessage = error.message
    // // The email of the user's account used.
    // var email = error.email
    // // The firebase.auth.AuthCredential type that was used.
    // var credential = error.credential

    window.localStorage.removeItem(FB_LS_TOKEN)
    console.log(error)
    return Promise.reject(error)
  })
}

export const loginGoogle = () => {
  var provider = new frbs.auth.GoogleAuthProvider()
  return Auth.signInWithPopup(provider).then((result) => {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken
    // The signed-in user info.
    var user = result.user
    // ...
    State.user = user
    State.token = token
    window.localStorage.setItem(FB_LS_TOKEN, token)

    return Promise.resolve(State.user)
  }).catch((error) => {
    // // Handle Errors here.
    // var errorCode = error.code
    // var errorMessage = error.message
    // // The email of the user's account used.
    // var email = error.email
    // // The firebase.auth.AuthCredential type that was used.
    // var credential = error.credential

    // window.localStorage.removeItem(FB_LS_TOKEN)
    console.log(error)
    return Promise.reject(error)
  })
}

export const logout = () => {
  return Auth.signOut()
}
